const BoardOwnershipType = {
	TEAM: 'team',
	USER: 'user',
} as const;

export default BoardOwnershipType;
